import React from "react";
import { Link } from "react-router-dom";
import { Package, ArrowRight } from "lucide-react";
import { BUNDLE_LIST } from "@/data/bundles";

export const PdpAddToBox = ({ product }) => {
  const handles = product.collectionHandles || [];
  const eligible = BUNDLE_LIST.filter((b) => b.collectionHandles.some((h) => handles.includes(h)));
  if (!eligible.length) return null;

  return (
    <div
      className="mb-6 rounded-2xl p-4 sm:p-5"
      style={{
        background: "linear-gradient(150deg, rgba(251,234,240,0.7), rgba(251,238,214,0.6))",
        border: "1px solid rgba(197,152,90,0.35)",
      }}
      data-testid="pdp-add-to-box"
    >
      <p className="text-[10px] tracking-[0.34em] uppercase font-semibold text-gold mb-3 inline-flex items-center gap-2">
        <Package size={12} /> Add this to a box & save
      </p>
      <div className="flex flex-col gap-2">
        {eligible.map((b) => (
          <Link
            key={b.slug}
            to={`/bundle/${b.slug}?pick=${encodeURIComponent(product.id)}`}
            className="group flex items-center justify-between gap-3 px-4 py-3 rounded-full bg-plum text-cream transition-[transform,background-color] hover:bg-[#5d3946] hover:-translate-y-0.5 active:scale-[0.98]"
            data-testid={`pdp-add-to-box-${b.slug}`}
          >
            <span className="text-[11px] tracking-[0.22em] uppercase font-semibold">
              + Add to {b.name}
            </span>
            <span className="text-[11px] tracking-[0.12em] text-[#F4D58D] inline-flex items-center gap-1.5">
              {b.qty} for ₹{b.price.toLocaleString("en-IN")}
              {b.hasFreeGift ? " + Gift" : ""}
              <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PdpAddToBox;
